import { useLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import { StartKyc } from './resources/components';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ hasHeader: true, hasDrawer: true });

    const company = useCompanyBasedOnUrl();

    return (
        <>
            <Helmet title={messages.title({ companyName: company?.displayName })} />

            <StartKyc />
        </>
    );
};

export default Page;
